import React from 'react'
import { useHistory } from 'react-router-dom'
import { APPNAME } from 'app/constants/APIKEYS'
import { useToken } from 'app/hooks'
import { Switch, Button } from 'antd'
import styled from 'styled-components'

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  height: 32px;
  padding: 4px 6px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  cursor: pointer;
  user-select: none;
  width: fit-content;

  .logo-button {
    color: #1890ff;
    font-size: 14px;
    font-weight: bold;
    padding: 0;
    height: auto;
    line-height: 1;
    border: none;
    background: transparent;

    &:hover {
      color: #40a9ff;
      background: transparent;
    }
  }

  .logo-switch {
    .ant-switch-inner {
      font-size: 10px;
    }
  }
`

const CompactLogo: React.FC = () => {
  const navigation = useHistory()
  const { data: token } = useToken()

  const handleClick = () => {
    navigation.push('/')
  }

  const handleSwitchChange = (checked: boolean) => {
    if (checked) {
      window.location.href = '' + process.env.REACT_APP_COINA_URL + token
    } else {
      navigation.push('/')
    }
  }

  return (
    <LogoContainer onClick={handleClick}>
      {(APPNAME === "THEBIT" || APPNAME === "GLOBALBIT") ? (
        <Switch
          className="logo-switch"
          size="small"
          checkedChildren="COIN"
          unCheckedChildren="GLOBAL"
          onChange={handleSwitchChange}
        />
      ) : (
        <Button
          type="text"
          className="logo-button"
          onClick={handleClick}
        >
          {APPNAME}
        </Button>
      )}
    </LogoContainer>
  )
}

export default React.memo(CompactLogo)